export const LOCAL_STORAGE_COPIED_ACTION_KEY = 'Workflows:CopiedAction';